import * as Actions from '../actionsgazeta';

const initialState = [];

const noticiasMaisLidas = function (state = initialState, action) {
    switch (action.type) {
        case Actions.SET_NOTICIAS_MAISLIDAS_DATA:
            {
                return action.payload

            }
        case Actions.CLEAR_NOTICIAS_MAISLIDAS_DATA:
            {
                return state;
            }
        default:
            {
                return state
            }
    }
};

export default noticiasMaisLidas;
